export default {
  notifications: `/v1/notifications/notifications`,
  groups: `/v1/notifications/groups`,
  notification: (id: string) => `/v1/notifications/notifications/show/${id}`,
  notifications_count: `/v1/notifications/notifications/count`,
  set_visited: (id: string) =>
    `/v1/notifications/notifications/${id}/set_visited`
};
